import type { Thread } from '../services/api';

/**
 * A thread is taken while `takenUntil` is still ahead of us. The assistant stays quiet
 * for that whole window, so the conversation is waiting on a person - which is what
 * the listing highlights and what unlocks the reply box.
 *
 * `now` is required rather than defaulted: the answer goes stale on its own, and a
 * caller that reads the clock once has to say so instead of looking correct by
 * accident.
 */
export function isThreadTaken(thread: Thread, now: number): boolean {
  if (!thread.takenUntil) return false;

  return new Date(thread.takenUntil).getTime() > now;
}
